// TODO: create queries and commands files

import { Nullable } from "../../../common/types/nullable";

// TODO: can be removed once all tasks are migrated to the generic presentation/actions model
export enum HrTaskType {
  CertificateExpiring = "CertificateExpiring",
  EmploymentEnding = "EmploymentEnding",
  EmploymentHasEnded = "EmploymentHasEnded",
  WorkPermitExpiring = "WorkPermitExpiring",
  ProbationEnding = "ProbationEnding",
  CertificateApprovalNeeded = "CertificateApprovalNeeded",
  WorkAgreementNotAccepted = "WorkAgreementNotAccepted",
  CustomerAnswerToIntroducedTalent = "CustomerAnswerToIntroducedTalent",
  OrderExpired = "OrderExpired",
  TargetedShiftVariationMismatch = "TargetedShiftVariationMismatch",
  TargetedShiftDidNotFindTarget = "TargetedShiftDidNotFindTarget",
  TargetedShiftTargetSwitched = "TargetedShiftTargetSwitched",
  AcceptedLongWorkAgreement = "AcceptedLongWorkAgreement",
  FirstShortEmployment = "FirstShortEmployment",
  TenthShortEmployment = "TenthShortEmployment",
  NewLongEmployment = "NewLongEmployment",
  TalentWorkHoursLimitExceeded = "TalentWorkHoursLimitExceeded",
  SickLeaveShortAbsencesX3 = "SickLeaveShortAbsencesX3",
  SickLeaveLongAbsence = "SickLeaveLongAbsence",
  SickLeaveEntryThreshold = "SickLeaveEntryThreshold",
}

// Mirrors the backend's generic presentation/actions HR task model
// (events-matching HrTasks.kt, srv-projections HrTaskViewContent.kt).
export enum HrTaskContentRowType {
  TEXT = "TEXT",
  LINK = "LINK",
}

export enum HrTaskActionType {
  NAVIGATE = "NAVIGATE",
  CONFIRM_COMPLETION = "CONFIRM_COMPLETION",
}

export interface LogicalLinkTargetTalentProfile {
  type: "TALENT_PROFILE";
  talentId: string;
}

export interface LogicalLinkTargetTalentEmployment {
  type: "TALENT_EMPLOYMENT";
  talentId: string;
  employmentId: string;
}

export interface LogicalLinkTargetTalentEmployments {
  type: "TALENT_EMPLOYMENTS";
  talentId: string;
}

export interface LogicalLinkTargetWorkAgreementEdit {
  type: "WORK_AGREEMENT_EDIT";
  bundleId: string;
  workAgreementId: string;
}

export interface LogicalLinkTargetOrder {
  type: "ORDER";
  bundleId: string;
}

export interface LogicalLinkTargetTalentAssignment {
  type: "TALENT_ASSIGNMENT";
  talentId: string;
  assignmentId: string;
}

export interface LogicalLinkTargetTalentEntries {
  type: "TALENT_ENTRIES";
  talentId: string;
}

export type LogicalLinkTarget =
  | LogicalLinkTargetTalentProfile
  | LogicalLinkTargetTalentEmployment
  | LogicalLinkTargetTalentEmployments
  | LogicalLinkTargetWorkAgreementEdit
  | LogicalLinkTargetOrder
  | LogicalLinkTargetTalentAssignment
  | LogicalLinkTargetTalentEntries;

export interface LogicalLink {
  target: LogicalLinkTarget;
  openInNewTab: boolean;
}

export interface HrTaskContentRow<Text = HrTaskRowText> {
  type: HrTaskContentRowType;
  text: Text;
  link?: LogicalLink;
}

export interface NavigateAction {
  type: HrTaskActionType.NAVIGATE;
  link: LogicalLink;
}

export interface ConfirmationAction<Text = HrTaskRowText> {
  type: HrTaskActionType.CONFIRM_COMPLETION;
  title: Text;
  rows: HrTaskContentRow<Text>[];
}

export interface HrTaskPresentation<Text = HrTaskRowText> {
  title: Text;
  rows: HrTaskContentRow<Text>[];
}

export interface HrTaskActions<Text = HrTaskRowText> {
  defaultAction?: NavigateAction | null;
  confirmation?: ConfirmationAction<Text> | null;
}

export interface HrTasklistQuery {
  expertId?: string;
  expertIds?: string;
  atDate: string;
  pageSize?: number;
  includeNotAssigned?: string; // boolean
  includeNotVisible?: string; // boolean
  includeAcknowledged?: string; // boolean
  cursor?: Nullable<string>;
  search?: string;
  types?: string;
  visibilityStartFrom?: string;
  visibilityStartTo?: string;
}

interface HrTaskAcked {
  at: EpochTimeStamp;
  byExpertId: string;
}

export interface HrTaskRowText {
  fi: string;
  en: string;
  sv: string;
}

export interface HrTaskResponse {
  id: string;
  talentId?: string | null;
  expertId?: string;
  type: HrTaskType;
  visibilityStart?: EpochTimeStamp;
  visibilityEnd?: EpochTimeStamp;
  date?: string; // yyyy-MM-dd
  aggregateId: string;
  aggregateDetailId?: string;
  canManuallyAcknowledge: boolean;
  manuallyAcknowledged?: HrTaskAcked;
  employerName?: string;
  paymentPeriodClassId?: string;
  rowTitle: string;
  rowText: HrTaskRowText;
  rowIcon?: string;

  // Both fields must be present to use the native contract; partial documents use legacy adaptation.
  presentation?: HrTaskPresentation | null;
  actions?: HrTaskActions | null;
}

// Localized display contract used by both the card and completion dialog.
export interface HrTask {
  id: string;
  canManuallyAcknowledge: boolean;
  presentation: HrTaskPresentation<string>;
  actions: HrTaskActions<string> & { confirmation: ConfirmationAction<string> };
}

export interface HrTasklistkRows {
  rows: HrTaskResponse[];
  cursor?: string;
}

export interface HrTaskAck {
  hrTaskId: string;
  stamp: EpochTimeStamp;
}

export interface HrTaskAcknowledged {
  expertId: string;
  stamp: EpochTimeStamp;
}
